module.exports = __webpack_public_path__ + "static/media/supermercado.2c86b240.svg";